/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Pátek`
};

const da_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Fredag`
};

const de_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Freitag`
};

const en_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Friday`
};

const es_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Viernes`
};

const fr_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Vendredi`
};

const hu_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Péntek`
};

const it_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Venerdì`
};

const nl_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Vrijdag`
};

const pl_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Piątek`
};

const pt_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Sexta-feira`
};

const sv_weekdays_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Fredag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const weekdays_friday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.weekdays_friday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("weekdays_friday", locale)
	if (locale === "cs") return cs_weekdays_friday(inputs)
	if (locale === "da") return da_weekdays_friday(inputs)
	if (locale === "de") return de_weekdays_friday(inputs)
	if (locale === "en") return en_weekdays_friday(inputs)
	if (locale === "es") return es_weekdays_friday(inputs)
	if (locale === "fr") return fr_weekdays_friday(inputs)
	if (locale === "hu") return hu_weekdays_friday(inputs)
	if (locale === "it") return it_weekdays_friday(inputs)
	if (locale === "nl") return nl_weekdays_friday(inputs)
	if (locale === "pl") return pl_weekdays_friday(inputs)
	if (locale === "pt") return pt_weekdays_friday(inputs)
	return sv_weekdays_friday(inputs)
};
export { weekdays_friday as "weekdays.friday" }